require('../modules/es.array.iterator');
require('../modules/es.string.iterator');
var getIteratorMethod = require('../internals/get-iterator-method');

module.exports = getIteratorMethod;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs3/node_modules/core-js-pure/es/get-iterator-method.js
// module id = Kjty
// module chunks = 0